import Installation from './Installation';

export default Installation;
